/**
 * @param {Element | string} elementOrSelector
 */
const getElement = elementOrSelector => {
	if (typeof elementOrSelector === 'string') {
		return document.querySelector(elementOrSelector);
	}

	return elementOrSelector;
};

/**
 * @param {Element} element
 */
const getElementValue = element => {
	return element.value || element.innerText;
};

/**
 * @param {string} data
 * @returns {string}
 */
const base64Decode = (data) => {
	const trimmedData = data?.trim();

	if (typeof Buffer === 'object') {
		return Buffer.from(trimmedData, 'base64');
	}

	return atob(trimmedData);
};

/**
 * Grabs data (value or innerHTML) from a specified element and removes it from the DOM. Returns the found value.
 * @param {Element | string} elementOrSelector
 * @param {boolean} base64 Decode base64 if true
 */
export const extractElement = (elementOrSelector, base64 = false) => {
	const element = getElement(elementOrSelector);

	if (element) {
		const rawValue = getElementValue(element);

		// Store value
		const value = base64
			? base64Decode(rawValue)
			: rawValue;

		// Remove self from DOM
		element.parentElement.removeChild(element);

		return value;
	}

	return void 0;
};
